export { PerlinNoise } from './PerlinNoise';
export { debugLog, debugWarn, setDebug } from './Logger';

/**
 * Format a number for player-facing display.
 * 1234 → "1.2K", 1500000 → "1.5M", 999 → "999"
 */
export function formatNumber(num: number): string {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toString();
}
